import { ColumnFilterClearTemplateOptions } from 'primereact/column';
import { Dispatch, FC, SetStateAction } from 'react';
import { FilterError } from '../../../../../types/types';
import Button from '../../../../Button/Button';
import { useTranslate } from '../../../../../hooks/context/useTranslate';
import { useColumnFilterRegistryContext } from '../../../../../hooks/context/useColumnFilterRegistryContext';
import { GridColumn } from '../../types';

export interface FilterClearTemplateProps {
  options: ColumnFilterClearTemplateOptions;
  column: GridColumn;
  setFilterErrors: Dispatch<SetStateAction<Record<string, FilterError>>>;
}

const FilterClearTemplate: FC<FilterClearTemplateProps> = ({
  options,
  column,
  setFilterErrors,
}) => {
  const { t } = useTranslate();
  const { markFilterSubmitted } = useColumnFilterRegistryContext();

  const onFilterClear = (
    options: ColumnFilterClearTemplateOptions,
    column: GridColumn,
    setFilterErrors: Dispatch<SetStateAction<Record<string, FilterError>>>
  ) => {
    try {
      options?.filterClearCallback();
      setFilterErrors((v) => ({ ...v, [column.name]: null }));
      // Clear is a real commit (just to an empty value), so FilterTemplate's unmount must not revert the freshly-cleared draft.
      markFilterSubmitted(column.name);
    } catch (error) {
      console.error('Filter clear failed for column', column.name, error);
    }
  };
  return (
    <Button
      id="additional-buttons-trigger"
      className="column-filter-clear-button"
      secondary
      onClick={() => onFilterClear(options, column, setFilterErrors)}
      disabled={column.mandatoryFilter}
    >
      {t('filterCancel')}
    </Button>
  );
};

export default FilterClearTemplate;
